import { render, staticRenderFns } from "./CouponVipPopupCustomer.vue?vue&type=template&id=f70c7bca&scoped=true&"
import script from "./CouponVipPopupCustomer.vue?vue&type=script&lang=js&"
export * from "./CouponVipPopupCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CouponVipPopupCustomer.vue?vue&type=style&index=0&id=f70c7bca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c7bca",
  null
  
)

export default component.exports